/**
 * Pure Helfer fuer das globale Hinweisband (KalleHinweis). Kein React.
 * Karteninhalt stammt aus Modellausgabe: nur Text, nie als HTML/Link verwendet.
 */
import { istNichtFreigeschaltet } from '../pages/dashboard/dashboardApi';

/** Spiegel von dauerauftragConfig.HINWEIS_POLL_MS (Frontend importiert nie aus core/backend). */
export const HINWEIS_POLL_MS = 60000;
export const HINWEIS_TEXT_MAX = 140;

/** Whitespace -> ein Leerzeichen, kuerzt mit „…“ moeglichst an einer Wortgrenze. */
export function kuerzeText(text: string, max: number = HINWEIS_TEXT_MAX): string {
  const eins = String(text ?? '').replace(/\s+/g, ' ').trim();
  if (eins.length <= max) return eins;
  const roh = eins.slice(0, Math.max(0, max - 1));
  const letzterRaum = roh.lastIndexOf(' ');
  const basis = letzterRaum > max * 0.5 ? roh.slice(0, letzterRaum) : roh;
  return `${basis.replace(/[\s.,;:]+$/, '')}…`;
}

function str(v: unknown): string {
  return typeof v === 'string' ? v : typeof v === 'number' ? String(v) : '';
}

/** Einzeilige Kurzaussage (≤ HINWEIS_TEXT_MAX) je Kartentyp; unbekannt -> ''. */
export function hinweisText(karte: unknown): string {
  if (!karte || typeof karte !== 'object') return '';
  const k = karte as Record<string, unknown>;
  const titel = str(k.titel);
  let out = '';
  switch (k.typ) {
    case 'hinweis':
    case 'text':
      out = str(k.text);
      break;
    case 'vorschlag':
      out = str(k.begruendung);
      break;
    case 'kennzahl':
      out = `${titel}: ${str(k.wert)}${str(k.einheit) ? ` ${str(k.einheit)}` : ''}`;
      break;
    case 'alarmliste': {
      const e = Array.isArray(k.eintraege) ? (k.eintraege as Array<Record<string, unknown>>) : [];
      const rot = e.filter((x) => x?.schwere === 'rot').length;
      const erster = e.length > 0 ? str(e[0]?.text) : '';
      out = `${e.length} Meldungen${rot > 0 ? ` (davon ${rot} rot)` : ''}${erster ? `: ${erster}` : ''}`;
      break;
    }
    case 'tabelle':
    case 'liste': {
      const n = Array.isArray(k.zeilen) ? k.zeilen.length : Array.isArray(k.eintraege) ? k.eintraege.length : 0;
      out = `${titel} · ${n} Einträge`;
      break;
    }
    case 'balken':
    case 'ring':
    case 'linie':
    case 'saeulen':
    case 'fortschritt':
      out = titel;
      break;
    default:
      return '';
  }
  return kuerzeText(out);
}

/** false genau bei 403 DASHBOARD_NICHT_FREIGESCHALTET, sonst weiterpollen. */
export function sollWeiterPollen(fehler: unknown): boolean {
  return !istNichtFreigeschaltet(fehler);
}
